import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import s from './actions.module.css';
import { context } from '../utils';
var Actions = function Actions(_ref) {
  var children = _ref.children;
  var _useContext = useContext(context),
    dataTest = _useContext.dataTest;
  var single = useMemo(function () {
    return React.Children.count(children) === 1;
  }, [children]);
  return React.createElement("div", {
    className: classNames(s.box, single && s.single),
    "data-test": dataTest && "".concat(dataTest, "-actions")
  }, children);
};
var isLegacyBrowser = typeof IntersectionObserver === 'undefined';
export var StickyActions = function StickyActions(_ref2) {
  var children = _ref2.children;
  var _useContext2 = useContext(context),
    dataTest = _useContext2.dataTest;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shadow = _useState2[0],
    setShadow = _useState2[1];
  var coverRef = useRef(null);
  useEffect(function () {
    if (isLegacyBrowser) {
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setShadow(!entry.isIntersecting);
      });
    });
    if (coverRef && coverRef.current) {
      observer.observe(coverRef.current);
    }
    return function () {
      observer.disconnect();
    };
  }, [setShadow]);
  if (isLegacyBrowser) {
    return React.createElement(Actions, null, children);
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    ref: coverRef,
    className: classNames(s.cover)
  }), React.createElement("div", {
    className: classNames(s.sticky, shadow && s.shadow),
    "data-test": dataTest && "".concat(dataTest, "-sticky-actions")
  }, React.createElement(Actions, null, children)));
};
export default Actions;